export default __webpack_public_path__ + "static/media/menu-adminWhite.15f46a7e.svg";